import React, { Suspense } from "react";
import LoadingE from "./LoadingE";

export default function WrapInSuspense({ children }) {
  return <Suspense fallback={<LoadingE />}>{children}</Suspense>;
}
